<ion-row>
  <ion-col class="ion-no-padding">
    <ion-card class="ion-no-margin airport-hero">
      <div class="img-container">
        <ion-img
          class="hero-banner-img"
          [src]="bannerInfo.image || placeholder"
        >
        </ion-img>
        <div class="item-overlay w100 ion-padding-top ion-margin-top">
          <ion-item lines="none" (click)="openModal()">
            <ion-thumbnail slot="start">
              <h2 style="margin: 25% auto" class="ion-text-center desc-text-color">
                {{ bannerInfo.code }}
              </h2>
            </ion-thumbnail>
            <ion-label class="d-grid airport-container">
              <h3 class="fs-4 font600 airport-name white-text-color line-2-clip">{{ bannerInfo.name }}</h3>
              <p class="fs-3 font500 white-text-color line-2-clip">
                {{ bannerInfo.city }} , {{ bannerInfo.country }}
              </p>
            </ion-label>
            <ion-label class="airport-time ion-text-center" slot="end">
              <h4 class="fs-3 font400 white-text-color">
                <ion-icon name="time-outline" class="white-icon-color"></ion-icon>
                {{ currentTime | smartdate : "shortTime" }}
              </h4>
              <p class="fs-3 font400 white-text-color">{{ bannerInfo?.weather?.temp }}° C</p>
            </ion-label>
          </ion-item>
          <div class="greetings ion-padding">
            <ion-label slot="start">
              <h2 class="fs-3 font500 white-text-color">{{"airport_companion.hero_banner.hey" | translate}}</h2>
              <br />
              <h2 class="fs-3 font500 white-text-color">{{"airport_companion.hero_banner.thank_you_text" | translate}}</h2>
              <h2 class="fs-3 font500 white-text-color">{{"airport_companion.hero_banner.let's_track_text" | translate}}</h2>
            </ion-label>
          </div>
          <ion-button
            routerLink="/flights"
            routerDirection="forward"
            class="ion-margin-start tertiary-btn track-flight"
            mode="ios"
            shape="round"
          >
            <ion-icon
              name="airplane-outline"
              class="rotate-314 primary-icon-color"
              slot="start"
            ></ion-icon>
            {{"airport_companion.hero_banner.track_flight" | translate}}
          </ion-button>
        </div>
      </div>
    </ion-card>
  </ion-col>
</ion-row>
